import { render, staticRenderFns } from "./EmailConfirmed.vue?vue&type=template&id=0f54d457&scoped=true"
import script from "./EmailConfirmed.vue?vue&type=script&lang=js"
export * from "./EmailConfirmed.vue?vue&type=script&lang=js"
import style0 from "./EmailConfirmed.vue?vue&type=style&index=0&id=0f54d457&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54d457",
  null
  
)

export default component.exports